import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

const Setup = () => {
  const [loading, setLoading] = useState(false);
  const [secretToken, setSecretToken] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const createAdminUser = async () => {
    if (!secretToken.trim()) {
      toast.error("Please enter the secret token");
      return;
    }

    if (!email.trim() || !password.trim()) {
      toast.error("Please enter both email and password");
      return;
    }

    if (password.length < 8) {
      toast.error("Password must be at least 8 characters long");
      return;
    }

    setLoading(true);

    try {
      const { data, error } = await supabase.functions.invoke('create-admin-user', {
        body: {
          email: email.trim(),
          password: password.trim(),
          secretToken: secretToken.trim()
        }
      });

      if (error) {
        toast.error(error.message || "Failed to create admin user");
        return;
      }

      if (data?.error) {
        toast.error(data.error);
        return;
      }

      toast.success("Admin user created successfully! You can now login.");
      setSecretToken("");
      setEmail("");
      setPassword("");
    } catch (err: any) {
      toast.error(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="w-full max-w-md p-8 border-accent/20">
        <div className="text-center mb-8">
          <img src="/assets/logo.png" alt="OneWeekMVPs" className="h-10 mx-auto mb-6" />
          <h1 className="font-heading text-3xl mb-2">Admin Setup</h1>
          <p className="text-muted-foreground">Create the admin user account</p>
        </div>

        <div className="space-y-4">
          <div>
            <Label htmlFor="email">Admin Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter admin email"
              disabled={loading}
            />
          </div>

          <div>
            <Label htmlFor="password">Admin Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password (min 8 characters)"
              disabled={loading}
            />
          </div>

          <div>
            <Label htmlFor="token">Secret Token</Label>
            <Input
              id="token"
              type="password"
              value={secretToken}
              onChange={(e) => setSecretToken(e.target.value)}
              placeholder="Enter your ADMIN_CREATION_TOKEN"
              disabled={loading}
            />
            <p className="text-sm text-muted-foreground mt-2">
              This is the ADMIN_CREATION_TOKEN you configured in your secrets
            </p>
          </div>

          <Button 
            onClick={createAdminUser} 
            className="w-full" 
            size="lg" 
            disabled={loading}
          >
            {loading ? "Creating Admin User..." : "Create Admin User"}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default Setup;
